import cx from 'classnames'
import { type KeenSliderInstance } from 'keen-slider'

interface GalleryCarouselArrowLeftProps {
  slider: KeenSliderInstance | null
  label: string
  id?: string
  cornerControls?: boolean
}

const GalleryCarouselArrowLeft = ({
  label,
  slider,
  cornerControls,
}: GalleryCarouselArrowLeftProps) => {
  return (
    <button
      onClick={() => slider?.prev()}
      aria-label={label}
      className={cx(
        'w-8 h-8 p-2 rounded-full',
        'bg-transparent transition-colors duration-300 hover:bg-pageBG hover:bg-opacity-20',
        {
          'absolute bottom-3 right-11': cornerControls,
        },
      )}
    >
      {/* <Icon
        name="ArrowLeft" // TODO: Missing icon. Not found in design.
        id={`previous-${id}`}
        className="block"
      /> */}
    </button>
  )
}

export default GalleryCarouselArrowLeft
